import { useCallback } from 'react';

import { type Role, useAuthStore } from '@/entities/auth';

export const useAuthorization = () => {
  const { roles } = useAuthStore();

  const safeRoles = (roles || []).filter((role): role is Role => Boolean(role) && typeof role === 'string');

  const hasRole = useCallback(
    (requiredRole: Role) => {
      if (!requiredRole) return false;
      return safeRoles.some((userRole) => userRole.includes(requiredRole));
    },
    [safeRoles]
  );

  const hasAnyRole = useCallback(
    (requiredRoles: Role[]) => {
      if (!requiredRoles?.length) return false;
      return requiredRoles.some((role) => role && safeRoles.find((r) => r.includes(role)));
    },
    [safeRoles]
  );

  const hasAllRoles = useCallback(
    (requiredRoles: Role[]) => {
      if (!requiredRoles?.length) return false;
      return requiredRoles.every((role) => role && safeRoles.some((userRole) => userRole.includes(role)));
    },
    [safeRoles]
  );

  return {
    currentRoles: safeRoles,
    hasRole,
    hasAnyRole,
    hasAllRoles,
  };
};
